import { useGetSingleClinic } from "../../../../hooks/useGetClinics";
//todo refactor to tier system.
export function useFetchClinicData(clinicId) {
  const { data: apiData, isLoading, error } = useGetSingleClinic(clinicId);

  const data = {
    tier: apiData?.tier ?? [] ,
    clinic: apiData?.clinic ?? [],
    users: apiData?.users ?? [] ,
  };

  return { data, isLoading, error };
}
